import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TEditBranchDetailsReduxParams } from '~types/feat/branch';

export default function* watchEditBranchDetails(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchEditBranchDetailsAttempt', handleEditBranchDetails, api);
}

function* handleEditBranchDetails(api: BranchGateway, action: PayloadAction<TEditBranchDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const isEditing = reduxState.branch.modals.isEditing;
    const {
        regionId,
        branchId,
        branchCode,
        branchName,
        status,
    } = action.payload;

    if (!regionId || !branchId || !branchName || !branchCode) {
        yield put(combinedActions.branchEditBranchDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.editBranchDetails], {
        authToken,
        regionId,
        branchId,
        branchCode,
        branchName,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchEditBranchDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {

        if (isEditing) {
            yield put(combinedActions.branchSetBranchDetailsModalIsOpen(false));
        } else {
            yield put(combinedActions.branchSetDeleteBranchModalIsOpen(false));
        }

        yield put(combinedActions.branchSetBranchDetailsModalIsEditing(false));
        yield put(combinedActions.branchEditBranchDetailsSuccess());
        yield put(combinedActions.branchSetGetBranchListingIndex({ index: 0 }));
        yield put(combinedActions.branchGetBranchListingAttempt()); // for rendering the list in branch management
        yield put(combinedActions.branchGetAllBranchesAttempt()); // for filters (separate API to get all)

        toast.success(SuccessMessages.BranchUpdateBranchSuccess);
    }
}
